import React from 'react';

export function getUiLang() {
  if (typeof localStorage === 'undefined') return 'ru';
  return localStorage.getItem('ui_lang') || 'ru';
}

export function setUiLang(lang) {
  try { localStorage.setItem('ui_lang', lang); } catch (_) { }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('ui_lang_changed', { detail: { lang } }));
  }
}

export function useUiLang() {
  const [lang, setLang] = React.useState(getUiLang());
  React.useEffect(() => {
    const onChange = (e) => setLang(e?.detail?.lang || getUiLang());
    if (typeof window !== 'undefined') window.addEventListener('ui_lang_changed', onChange);
    return () => { if (typeof window !== 'undefined') window.removeEventListener('ui_lang_changed', onChange); };
  }, []);
  return lang;
}

export function pickSurahName(meta, uiLang) {
  if (!meta) return '';
  if (uiLang === 'ru') return meta.russianName || meta.englishName || meta.name || '';
  if (uiLang === 'en') return meta.englishName || meta.name || '';
  return meta.name || meta.englishName || '';
}

const labels = {
  ru: {
    loading: 'Загрузка...',
    play: 'Воспроизвести',
    translation: 'Перевод',
    copy: 'Копировать',
    share: 'Поделиться',
    tafsirs: 'Тафсиры',
    ayahs: 'аятов',
    surah: 'Сура', juz: 'Джуз', hizb: 'Хизб', page: 'Страница',

    tab_home: 'Главная', tab_quran: 'Коран', tab_bookmarks: 'Закладки', tab_settings: 'Настройки',
    tabs_ayahs: 'Аяты',
    tabs_surahs: 'Суры', tabs_juz: 'Джузы', tabs_hizb: 'Хизбы', tabs_pages: 'Страницы',
    all: 'Все',

    search_quran: 'Поиск по Корану...',
    search_surah: 'Поиск суры...',
    search_placeholder: 'Сура, 2:255, джуз 5, хизб 10, стр 250...',
    go_to_ref: 'Перейти к {ref}', open_surah: 'Открыть суру {n}',

    settings: 'Настройки',
    theme: 'Тема оформления', light: 'Светлая', dark: 'Тёмная',
    ui_language: 'Язык интерфейса',
    reciter: 'Чтец (Рецитация)',
    quran_font_style: 'Стиль шрифта Корана',
    font_size_cards: 'Размер шрифта аятов (режим карточек)',
    wbw: 'Слово за слово', transliteration: 'Транслитерация (произношение)',
    wbw_translation: 'Перевод (слово за слово)',
    wbw_translation_lang: 'Язык пословного перевода',
    wbw_translation_lang_ru: 'Русский',
    wbw_translation_lang_en: 'Английский',
    display: 'Отображать', under_word: 'Под словом', on_click: 'При нажатии',
    translation_title: 'Перевод', show_translation: 'Показывать перевод',
    favorites_translations: 'Избранные переводы', font_size: 'Размер шрифта',
    choose_translations: 'Выберите переводы',
    search_translation: 'Поиск перевода...',
    selected_of_5: 'Выбрано {n} из 5',
    popular: 'Популярные',
    other_langs: 'Другие языки',
    nothing_found: 'Ничего не найдено',
    done: 'Готово',
    app_data: 'Данные приложения', clear_data: 'Очистить все данные',
    reset_settings: 'Сбросить настройки',

    greet: 'Ассаламу алейкум, Пользователь!',
    free_tier: 'Бесплатный тариф',
    read_quran: 'Читать Коран',
    my_bookmarks: 'Мои закладки',
    quick_access: 'Быстрый доступ',
    access_surahs: 'По сурам', access_juz: 'По джузам', access_hizb: 'По хизбам', access_pages: 'По страницам',
    mecca: 'Мекка', medina: 'Медина',
    search_juz: 'Поиск джуза...', search_hizb: 'Поиск хизба...', search_page: 'Поиск страницы...',
    continue_reading: 'Продолжить чтение',

    download: 'Скачать', speed: 'Скорость', reciter_menu: 'Выбор чтеца', volume: 'Громкость',
    prev_ayah: 'Предыдущий аят', next_ayah: 'Следующий аят', close: 'Закрыть', normal: 'Обычный',
    pause: 'Пауза', menu: 'Меню',
    loading_bookmarks: 'Загрузка закладок...',
    bookmarks_empty: 'Закладок пока нет',
    no_bookmarks_in_category: 'В этой категории закладок нет',
    delete_bookmark: 'Удалить закладку',
    cancel: 'Отмена',
    delete: 'Удалить',
    yes: 'Да',
    no: 'Нет',
    share_button: 'Поделиться',
    settings: 'Настройки',
    add_bookmark: 'Добавить закладку',
    remove_bookmark: 'Удалить закладку',
    bookmark_hint: 'Нажмите на значок закладки рядом с аятом, чтобы сохранить его',

    tafsir: 'Тафсир', select_surah: 'Выберите суру', ayah_placeholder: 'Аят', language: 'Язык', reading_group: 'Вы читаете тафсир для группы аятов {from} до {to}', not_found: 'Тафсир не найден. Убедитесь, что файлы тафсиров скачаны.',

    quran_label: 'Коран', forwarded_from: 'Переслано из', send_to_chat: 'Отправить в чат', copy_link: 'Копировать ссылку', link_copied: 'Ссылка скопирована в буфер обмена', copy_failed: 'Не удалось скопировать', share_open_failed: 'Не удалось открыть окно отправки', ayah_copied: 'Аят скопирован в буфер обмена', ayah_copy_failed: 'Не удалось скопировать аят',

    theme_title: 'Тема оформления',
    ui_language_title: 'Язык интерфейса',
    current_reciter: 'Текущий чтец',
    quran_font_style_title: 'Стиль шрифта Корана',
    font_size_cards_title: 'Размер шрифта аятов (режим карточек)',
    wbw_title: 'Слово за слово',
    display_title: 'Отображать', under_word_value: 'Под словом', on_click_value: 'При нажатии',
    translation_section: 'Перевод', show_translation_label: 'Показывать перевод',
    selected_translations: 'Избранные переводы', not_selected: 'Не выбрано', selected_n: 'Выбрано {n}',
    app_data_title: 'Данные приложения', clear_all_data: 'Очистить все данные',
    light: 'Светлая', dark: 'Тёмная',
    font_style_uthmani: 'Усмани', font_style_tajweed: 'Таджвид', font_style_indopak: 'Индопак',
    by_ayahs: 'По аятам', reading_mode: 'Режим чтения',
    ayah: 'аят',
    delete_confirm_title: 'Удалить закладку?', delete_confirm_msg: 'Вы уверены что хотите удалить эту закладку?',
    khatm_title: 'Хатм',
    khatm_subtitle: 'Создавайте цели чтения джузов и следите за прогрессом',
    khatm_new_goal: 'Новая цель',
    khatm_new_goal_title: 'Новая цель',
    khatm_goals_title: 'Мои цели',
    khatm_active_tab: 'Активные',
    khatm_completed_tab: 'Завершённые',
    khatm_no_active: 'Активных целей пока нет',
    khatm_no_completed: 'Завершённых целей пока нет',
    khatm_details_title: 'Детали цели',
    khatm_juz_range: 'Джузы {from}-{to}',
    khatm_auto_title: 'Хатм джузов {from}-{to}',
    khatm_read_stats: 'Прочитано {read} из {total} аятов',
    khatm_due_date_label: 'До {date}',
    khatm_juz_label: 'Джуз {n}',
    khatm_juz_stats: '{read}/{total} аятов · {percent}%',
    khatm_mark_done: 'Отметить',
    khatm_reset: 'Сбросить',
    khatm_cancel_goal: 'Отменить цель',
    khatm_complete_goal: 'Завершить цель',
    khatm_confirm_cancel: 'Отменить эту цель?',
    khatm_confirm_complete: 'Завершить эту цель?',
    khatm_days_left: 'Осталось {n} дн.',
    khatm_days_overdue: 'Срок прошёл',
    khatm_name_placeholder: 'Название (необязательно)',
    khatm_from_juz: 'От джуза',
    khatm_to_juz: 'До джуза',
    khatm_select_juz_placeholder: 'Выберите джуз',
    khatm_days_question: 'За сколько дней хотите завершить?',
    khatm_create_submit: 'Создать цель',
    khatm_create_submitting: 'Создание...',
    khatm_read_juz_btn: 'Читать джуз {n}',
    khatm_read_btn: 'Читать',
    khatm_status_done: 'Цель выполнена',
    khatm_status_overdue: 'Срок цели прошёл',
    khatm_col_read: 'Прочитано',
    khatm_group: 'Коллективная',
    khatm_group_active_tab: 'Активные коллективные',
    khatm_group_members_count: 'Сколько участников (кроме вас)?',
    khatm_group_username_placeholder: '@username',
    khatm_group_members: 'Участники',
    khatm_group_progress_label: 'Общий прогресс',
    khatm_you: 'Вы',
    khatm_invite_text: 'Приглашение в коллективный хатм',
    open_chat: 'Открыть чат',
    khatm_invites_tab: 'Приглашения',
    khatm_no_invites: 'Приглашений нет',
    khatm_invite_for_goal: 'Приглашение в цель',
    khatm_invite_accept: 'Принять',
    khatm_invite_decline: 'Отказать',
    khatm_daily_hint: 'Чтобы успеть, читайте ≈{n} аятов в день',
    khatm_daily_hint_group: 'Чтобы группа успела, нужно читать ≈{n} аятов в день',
    khatm_from_user: 'Пригласил {user}',
    khatm_leave_goal: 'Покинуть цель',
    khatm_confirm_leave: 'Покинуть эту цель?',

    reading_progress_title: 'Прогресс чтения',
    reading_progress_subtitle: 'Отслеживайте, сколько аятов каждой суры вы уже прочитали',
    reading_progress_tab_reading: 'Читаете',
    reading_progress_tab_completed: 'Прочитано',
    reading_progress_tab_all: 'Все',
    reading_progress_button: 'Прогресс чтения',
    reading_progress_reset_button: 'Сбросить прогресс',
    reading_progress_reset_confirm: 'Сбросить весь прогресс чтения?',
    loading_page: 'Загрузка страницы {n}...',
    loading_reading_mode: 'Загрузка режима чтения...',
  },
  en: {
    loading: 'Loading...',
    play: 'Play',
    translation: 'Translation',
    copy: 'Copy',
    share: 'Share',
    tafsirs: 'Tafsirs',
    ayahs: 'ayahs',
    surah: 'Surah', juz: 'Juz', hizb: 'Hizb', page: 'Page',
    tab_home: 'Home', tab_quran: 'Quran', tab_bookmarks: 'Bookmarks', tab_settings: 'Settings',
    tabs_ayahs: 'Ayahs',
    tabs_surahs: 'Surahs', tabs_juz: 'Juz', tabs_hizb: 'Hizb', tabs_pages: 'Pages',
    all: 'All',
    search_surah: 'Search surah...',
    search_quran: 'Search the Quran...',
    search_placeholder: 'Surah, 2:255, juz 5, hizb 10, p. 250...',
    go_to_ref: 'Go to {ref}', open_surah: 'Open surah {n}',
    settings: 'Settings',
    theme: 'Theme', light: 'Light', dark: 'Dark',
    ui_language: 'Interface language',
    reciter: 'Reciter',
    quran_font_style: 'Quran font style',
    font_size_cards: 'Ayah font size (cards mode)',
    wbw: 'Word-by-word', transliteration: 'Transliteration',
    wbw_translation: 'Word-by-word translation',
    wbw_translation_lang: 'Word-by-word language',
    wbw_translation_lang_ru: 'Russian',
    wbw_translation_lang_en: 'English',
    display: 'Display', under_word: 'Under word', on_click: 'On click',
    translation_title: 'Translation', show_translation: 'Show translation',
    favorites_translations: 'Selected translations', font_size: 'Font size',
    choose_translations: 'Choose translations',
    search_translation: 'Search translation...',
    selected_of_5: 'Selected {n} of 5',
    popular: 'Popular',
    other_langs: 'Other languages',
    nothing_found: 'Nothing found',
    done: 'Done',
    app_data: 'App data', clear_data: 'Clear all data',
    reset_settings: 'Reset settings',
    greet: 'Assalamu alaykum!',
    free_tier: 'Free plan',
    read_quran: 'Read Quran',
    my_bookmarks: 'My bookmarks',
    quick_access: 'Quick access',
    access_surahs: 'By surahs', access_juz: 'By juz', access_hizb: 'By hizb', access_pages: 'By pages',
    mecca: 'Mecca', medina: 'Medina',
    search_juz: 'Search juz...', search_hizb: 'Search hizb...', search_page: 'Search page...',
    continue_reading: 'Continue reading',

    download: 'Download', speed: 'Speed', reciter_menu: 'Choose reciter', volume: 'Volume',
    prev_ayah: 'Previous ayah', next_ayah: 'Next ayah', close: 'Close', normal: 'Normal',
    pause: 'Pause', menu: 'Menu',
    loading_bookmarks: 'Loading bookmarks...',
    bookmarks_empty: 'No bookmarks yet',
    no_bookmarks_in_category: 'No bookmarks in this category',
    delete_bookmark: 'Delete bookmark',
    cancel: 'Cancel',
    delete: 'Delete',
    yes: 'Yes',
    no: 'No',
    share_button: 'Share',
    settings: 'Settings',
    add_bookmark: 'Add bookmark',
    remove_bookmark: 'Remove bookmark',
    bookmark_hint: 'Tap the bookmark icon next to an ayah to save it',

    tafsir: 'Tafsir', select_surah: 'Select surah', ayah_placeholder: 'Ayah', language: 'Language', reading_group: 'You are reading commentary for verses {from} to {to}', not_found: 'Tafsir not found. Make sure tafsir files are downloaded.',

    quran_label: 'Quran', forwarded_from: 'Forwarded from', send_to_chat: 'Send to chat', copy_link: 'Copy link', link_copied: 'Link copied to clipboard', copy_failed: 'Copy failed', share_open_failed: 'Failed to open share dialog', ayah_copied: 'Ayah copied to clipboard', ayah_copy_failed: 'Failed to copy ayah',

    theme_title: 'Theme',
    ui_language_title: 'Interface language',
    current_reciter: 'Current reciter',
    quran_font_style_title: 'Quran font style',
    font_size_cards_title: 'Ayah font size (cards mode)',
    wbw_title: 'Word-by-word',
    display_title: 'Display', under_word_value: 'Under word', on_click_value: 'On click',
    translation_section: 'Translation', show_translation_label: 'Show translation',
    selected_translations: 'Selected translations', not_selected: 'Not selected', selected_n: 'Selected {n}',
    app_data_title: 'App data', clear_all_data: 'Clear all data',
    light: 'Light', dark: 'Dark',
    font_style_uthmani: 'Uthmani', font_style_tajweed: 'Tajweed', font_style_indopak: 'Indopak',
    by_ayahs: 'By ayahs', reading_mode: 'Reading mode',
    ayah: 'ayah',
    delete_confirm_title: 'Delete bookmark?', delete_confirm_msg: 'Are you sure you want to delete this bookmark?',
    khatm_title: 'Khatm',
    khatm_subtitle: 'Create juz reading goals and track your progress',
    khatm_new_goal: 'New goal',
    khatm_new_goal_title: 'New goal',
    khatm_goals_title: 'My goals',
    khatm_active_tab: 'Active',
    khatm_completed_tab: 'Completed',
    khatm_no_active: 'No active goals yet',
    khatm_no_completed: 'No completed goals yet',
    khatm_details_title: 'Goal details',
    khatm_juz_range: 'Juz {from}-{to}',
    khatm_auto_title: 'Khatm of juz {from}-{to}',
    khatm_read_stats: 'Read {read} of {total} ayahs',
    khatm_due_date_label: 'Until {date}',
    khatm_juz_label: 'Juz {n}',
    khatm_juz_stats: '{read}/{total} ayahs · {percent}%',
    khatm_mark_done: 'Mark done',
    khatm_reset: 'Reset',
    khatm_cancel_goal: 'Cancel goal',
    khatm_complete_goal: 'Complete goal',
    khatm_confirm_cancel: 'Cancel this goal?',
    khatm_confirm_complete: 'Mark this goal as completed?',
    khatm_days_left: '{n} days left',
    khatm_days_overdue: 'Deadline passed',
    khatm_name_placeholder: 'Name (optional)',
    khatm_from_juz: 'From juz',
    khatm_to_juz: 'To juz',
    khatm_select_juz_placeholder: 'Select juz',
    khatm_days_question: 'In how many days do you want to finish?',
    khatm_create_submit: 'Create goal',
    khatm_create_submitting: 'Creating...',
    khatm_read_juz_btn: 'Read juz {n}',
    khatm_read_btn: 'Read',
    khatm_status_done: 'Goal completed',
    khatm_status_overdue: 'Goal deadline passed',
    khatm_col_read: 'Read',
    khatm_group: 'Group goal',
    khatm_group_active_tab: 'Active group',
    khatm_group_members_count: 'How many members (besides you)?',
    khatm_group_username_placeholder: '@username',
    khatm_group_members: 'Participants',
    khatm_group_progress_label: 'Group progress',
    khatm_you: 'You',
    khatm_invite_text: 'Invitation to group khatm',
    open_chat: 'Open chat',
    khatm_invites_tab: 'Invites',
    khatm_no_invites: 'No invites',
    khatm_invite_for_goal: 'Invitation to goal',
    khatm_invite_accept: 'Accept',
    khatm_invite_decline: 'Decline',
    khatm_daily_hint: 'To finish on time, read about {n} ayahs per day',
    khatm_daily_hint_group: 'For the group to finish on time, read about {n} ayahs per day',
    khatm_from_user: 'Invited by {user}',
    khatm_leave_goal: 'Leave goal',
    khatm_confirm_leave: 'Leave this goal?',

    reading_progress_title: 'Reading progress',
    reading_progress_subtitle: 'Track how many ayahs of each surah you have read',
    reading_progress_tab_reading: 'Reading',
    reading_progress_tab_completed: 'Completed',
    reading_progress_tab_all: 'All',
    reading_progress_button: 'Reading progress',
    reading_progress_reset_button: 'Reset progress',
    reading_progress_reset_confirm: 'Reset all reading progress?',
    loading_page: 'Loading page {n}...',
    loading_reading_mode: 'Loading reading mode...',
  },
  ar: {
    loading: 'جارٍ التحميل...',
    play: 'تشغيل',
    translation: 'الترجمة',
    copy: 'نسخ',
    share: 'مشاركة',
    tafsirs: 'التفاسير',
    ayahs: 'آيات',
    surah: 'سورة', juz: 'جزء', hizb: 'حزب', page: 'صفحة',
    tab_home: 'الرئيسية', tab_quran: 'القرآن', tab_bookmarks: 'إشارات', tab_settings: 'الإعدادات',
    tabs_surahs: 'السور', tabs_juz: 'الأجزاء', tabs_hizb: 'الأحزاب', tabs_pages: 'الصفحات',
    all: 'الكل',
    search_surah: 'ابحث عن سورة...',
    search_quran: 'ابحث في القرآن...',
    search_placeholder: 'سورة، 2:255، جزء 5، حزب 10، صفحة 250...',
    go_to_ref: 'اذهب إلى {ref}', open_surah: 'افتح السورة {n}',
    settings: 'الإعدادات',
    theme: 'السمة', light: 'فاتح', dark: 'داكن',
    ui_language: 'لغة الواجهة',
    reciter: 'القارئ',
    quran_font_style: 'خط القرآن',
    font_size_cards: 'حجم خط الآيات (بطاقات)',
    wbw: 'كلمة بكلمة', transliteration: 'التهجئة الصوتية',
    wbw_translation: 'ترجمة كلمة بكلمة',
    wbw_translation_lang: 'لغة الترجمة كلمة بكلمة',
    wbw_translation_lang_ru: 'الروسية',
    wbw_translation_lang_en: 'الإنجليزية',
    display: 'العرض', under_word: 'تحت الكلمة', on_click: 'عند النقر',
    translation_title: 'الترجمة', show_translation: 'عرض الترجمة',
    favorites_translations: 'ترجمات مختارة', font_size: 'حجم الخط',
    choose_translations: 'اختر الترجمات',
    search_translation: 'ابحث عن ترجمة...',
    selected_of_5: 'المحدد {n} من 5',
    popular: 'شائع',
    other_langs: 'لغات أخرى',
    nothing_found: 'لا توجد نتائج',
    done: 'تم',
    app_data: 'بيانات التطبيق', clear_data: 'مسح كل البيانات',
    reset_settings: 'إعادة ضبط الإعدادات',
    greet: 'السلام عليكم',
    free_tier: 'الخطة المجانية',
    read_quran: 'قراءة القرآن',
    my_bookmarks: 'إشاراتي',
    quick_access: 'وصول سريع',
    access_surahs: 'حسب السور', access_juz: 'حسب الأجزاء', access_hizb: 'حسب الأحزاب', access_pages: 'حسب الصفحات',
    mecca: 'مكي', medina: 'مدني',
    search_juz: 'ابحث عن جزء...', search_hizb: 'ابحث عن حزب...', search_page: 'ابحث عن صفحة...',
    continue_reading: 'تابع القراءة',

    download: 'تنزيل', speed: 'السرعة', reciter_menu: 'اختيار القارئ', volume: 'الصوت',
    prev_ayah: 'الآية السابقة', next_ayah: 'الآية التالية', close: 'إغلاق', normal: 'عادي',
    pause: 'إيقاف مؤقت', menu: 'القائمة',
    loading_bookmarks: 'جاري تحميل الإشارات...',
    bookmarks_empty: 'لا توجد إشارات بعد',
    no_bookmarks_in_category: 'لا توجد إشارات في هذه الفئة',
    delete_bookmark: 'حذف الإشارة',
    cancel: 'إلغاء',
    delete: 'حذف',
    yes: 'نعم',
    no: 'لا',
    share_button: 'مشاركة',
    settings: 'الإعدادات',
    add_bookmark: 'إضافة إشارة',
    remove_bookmark: 'حذف الإشارة',
    bookmark_hint: 'اضغط على أيقونة الإشارة بجانب الآية لحفظها',

    tafsir: 'تفسير', select_surah: 'اختر السورة', ayah_placeholder: 'آية', language: 'اللغة', reading_group: 'تقرأ تفسير مجموعة الآيات {from} إلى {to}', not_found: 'لم يتم العثور على التفسير. تأكد من تنزيل الملفات.',

    quran_label: 'القرآن', forwarded_from: 'مرسل من', send_to_chat: 'إرسال للمحادثة', copy_link: 'نسخ الرابط', link_copied: 'تم نسخ الرابط', copy_failed: 'فشل النسخ', share_open_failed: 'تعذر فتح نافذة المشاركة', ayah_copied: 'تم نسخ الآية', ayah_copy_failed: 'تعذر نسخ الآية',

    theme_title: 'السمة',
    ui_language_title: 'لغة الواجهة',
    current_reciter: 'القارئ الحالي',
    quran_font_style_title: 'خط القرآن',
    font_size_cards_title: 'حجم خط الآيات (بطاقات)',
    wbw_title: 'كلمة بكلمة',
    display_title: 'العرض', under_word_value: 'تحت الكلمة', on_click_value: 'عند النقر',
    translation_section: 'الترجمة', show_translation_label: 'عرض الترجمة',
    selected_translations: 'ترجمات مختارة', not_selected: 'غير محدد', selected_n: 'المحدد {n}',
    app_data_title: 'بيانات التطبيق', clear_all_data: 'مسح كل البيانات',
    light: 'فاتح', dark: 'داكن',
    font_style_uthmani: 'عثماني', font_style_tajweed: 'تجويد', font_style_indopak: 'اندوباك',
    by_ayahs: 'حسب الآيات', reading_mode: 'وضع القراءة',
    ayah: 'آية',
    delete_confirm_title: 'حذف الإشارة؟', delete_confirm_msg: 'هل أنت متأكد أنك تريد حذف هذه الإشارة؟',
    khatm_title: 'ختم',
    khatm_subtitle: 'أنشئ أهدافاً لقراءة الأجزاء وتابع تقدمك',
    khatm_new_goal: 'هدف جديد',
    khatm_new_goal_title: 'هدف جديد',
    khatm_goals_title: 'أهدافي',
    khatm_active_tab: 'نشطة',
    khatm_completed_tab: 'مكتملة',
    khatm_no_active: 'لا توجد أهداف نشطة بعد',
    khatm_no_completed: 'لا توجد أهداف مكتملة بعد',
    khatm_details_title: 'تفاصيل الهدف',
    khatm_juz_range: 'الأجزاء {from}-{to}',
    khatm_auto_title: 'ختم الأجزاء {from}-{to}',
    khatm_read_stats: 'تم قراءة {read} من {total} آية',
    khatm_due_date_label: 'حتى {date}',
    khatm_juz_label: 'جزء {n}',
    khatm_juz_stats: '{read}/{total} آيات · {percent}%',
    khatm_mark_done: 'تمييز كمقروء',
    khatm_reset: 'إعادة التعيين',
    khatm_cancel_goal: 'إلغاء الهدف',
    khatm_complete_goal: 'إنهاء الهدف',
    khatm_confirm_cancel: 'هل تريد إلغاء هذا الهدف؟',
    khatm_confirm_complete: 'هل تريد إنهاء هذا الهدف؟',
    khatm_days_left: 'تبقى {n} يومًا',
    khatm_days_overdue: 'انتهت المدة',
    khatm_name_placeholder: 'الاسم (اختياري)',
    khatm_from_juz: 'من الجزء',
    khatm_to_juz: 'إلى الجزء',
    khatm_select_juz_placeholder: 'اختر جزءًا',
    khatm_days_question: 'في كم يوم تريد الإنهاء؟',
    khatm_create_submit: 'إنشاء الهدف',
    khatm_create_submitting: 'جارٍ الإنشاء...',
    khatm_read_juz_btn: 'قراءة الجزء {n}',
    khatm_read_btn: 'قراءة',
    khatm_status_done: 'اكتمل الهدف',
    khatm_status_overdue: 'انتهت مدة الهدف',
    khatm_col_read: 'مقروء',
    khatm_group: 'هدف جماعي',
    khatm_group_active_tab: 'الأهداف الجماعية النشطة',
    khatm_group_members_count: 'كم عدد المشاركين (غيرك)؟',
    khatm_group_username_placeholder: '@username',
    khatm_group_members: 'المشاركون',
    khatm_group_progress_label: 'التقدم الجماعي',
    khatm_you: 'أنت',
    khatm_invite_text: 'دعوة إلى ختم جماعي',
    open_chat: 'فتح الدردشة',
    khatm_invites_tab: 'الدعوات',
    khatm_no_invites: 'لا توجد دعوات',
    khatm_invite_for_goal: 'دعوة لهدف',
    khatm_invite_accept: 'قبول',
    khatm_invite_decline: 'رفض',
    khatm_daily_hint: 'لتحقيق الهدف، اقرأ تقريبًا {n} آية يوميًا',
    khatm_daily_hint_group: 'لكي ينهي الفريق في الوقت، اقرأوا تقريبًا {n} آية يوميًا',

    reading_progress_title: 'تقدم القراءة',
    reading_progress_subtitle: 'تتبع عدد الآيات المقروءة من كل سورة',
    reading_progress_tab_reading: 'تقرأون',
    reading_progress_tab_completed: 'مقروءة بالكامل',
    reading_progress_tab_all: 'الكل',
    reading_progress_button: 'تقدم القراءة',
    reading_progress_reset_button: 'إعادة التعيين',
    reading_progress_reset_confirm: 'هل تريد مسح كل تقدم القراءة؟',
    loading_page: 'جارٍ تحميل الصفحة {n}...',
    loading_reading_mode: 'جارٍ تحميل وضع القراءة...',
  }
};

export function t(key, vars) {
  const lang = getUiLang();
  const raw = (labels[lang] && labels[lang][key]) || (labels.en[key]) || key;
  if (!vars) return raw;
  return Object.keys(vars).reduce((acc, k) => acc.replace(new RegExp(`{${k}}`, 'g'), String(vars[k])), raw);
}
